interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "GMD";
};

const GMD: Currency = Object.freeze({
  "displayName": "Gambian Dalasi",
  "numericCode": 270,
  "defaultFractionDigits": 2,
  "subUnit": 100,
  "symbolSpaced": true,
  "symbolPosition": "after",
  "isoCode": "GMD",
  "symbol": "D"
});

export { GMD };
